import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { useSelector } from 'react-redux';

import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';

const Cierre = () => {
  const history = useHistory();
  const user = useSelector(state => state.auth.user);
  const { userPermissions } = useMantenedores();
  const permisos = userPermissions?.modules?.cierre || {};

  // Navegar a los submódulos
  const navigateToDiaADia = () => {
    history.push('/mantenedores/cierre/dia-a-dia');
  };

  const navigateToCierreAcumulado = () => {
    history.push('/mantenedores/cierre/acumulado');
  };

  const navigateToCierreMensual = () => {
    history.push('/mantenedores/cierre/cierre-mensual');
  };

  const navigateToEmailTemplates = () => {
    history.push('/mantenedores/cierre/email-templates');
  };

  return (
    <SimpleMantenedorLayout
      mantenedorId="cierre"
      title="Mantenedor de Cierre"
      subtitle="Gestión de cierres de conductores"
      iconColor="#007bff"
      breadcrumbs={[{ label: 'Cierre' }]}
      showBackButton={false}
    >
      <Row className="mt-4">
        <Col xs={12}>
          <div style={{ marginBottom: '24px' }}>
            <h4 style={{ color: '#212529', marginBottom: '8px' }}>
              Opciones de Cierre
            </h4>
            <p style={{ color: '#6c757d', marginBottom: '0' }}>
              Selecciona el tipo de cierre que deseas gestionar
            </p>
          </div>
        </Col>
      </Row>

      <Row className="g-4">
        {/* Submódulo Día a Día */}
        <Col xs={12} md={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToDiaADia : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e3f2fd',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaCalendarDay 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#1976d2' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Revisión Día a Día
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Consulta en tiempo real las entregas y pedidos de conductores por fecha específica
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToDiaADia();
                  }}
                >
                  <FaIcons.FaEye className="me-2" />
                  Ver Entregas
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Cierre Acumulado */}
        <Col xs={12} md={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToCierreAcumulado : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e8f5e8',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaCalendarCheck 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#2e7d32' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Cierre Acumulado
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Análisis financiero por rango de fechas con resumen detallado hasta 40 días
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-success"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToCierreAcumulado();
                  }}
                >
                  <FaIcons.FaChartLine className="me-2" />
                  Ver Análisis
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Cierre Mensual */}
        <Col xs={12} md={4}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: (permisos.canView && permisos.canCreate) ? 'pointer' : 'not-allowed',
              opacity: (permisos.canView && permisos.canCreate) ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={(permisos.canView && permisos.canCreate) ? navigateToCierreMensual : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#f3e5f5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaFileExcel 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#7b1fa2' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Cierre Mensual
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Genera el cierre mensual de entregas y descarga el reporte Excel con toda la información
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-success"
                  size="sm"
                  disabled={!(permisos.canView && permisos.canCreate)}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView && permisos.canCreate) navigateToCierreMensual();
                  }}
                >
                  <FaIcons.FaDownload className="me-2" />
                  Generar Cierre
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Segunda fila: Templates de Correo */}
      <Row className="g-4 mt-2">
        {/* Submódulo Email Templates */}
        <Col xs={12} md={4}>
          <Card
            className="h-100 shadow-sm border-0"
            style={{
              cursor: (permisos.canView) ? 'pointer' : 'not-allowed',
              opacity: (permisos.canView) ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToEmailTemplates : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#e8eaf6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaEnvelopeOpenText
                  style={{
                    fontSize: '2rem',
                    color: '#3949ab'
                  }}
                />
              </div>

              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Templates de Correo
              </h5>

              <p style={{
                color: '#6c757d',
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Gestiona y edita las plantillas HTML utilizadas para el envío de correos de cierre a conductores y empresas
              </p>

              <div className="mt-auto">
                <Button
                  variant="outline-primary"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToEmailTemplates();
                  }}
                >
                  <FaIcons.FaEdit className="me-2" />
                  Gestionar Templates
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Información adicional */}
      <Row className="mt-5">
        <Col xs={12}>
          <Card className="border-0 bg-light">
            <Card.Body className="p-4">
              <Row>
                <Col xs={12} md={8}>
                  <h6 style={{ color: '#495057', marginBottom: '12px' }}>
                    <FaIcons.FaInfoCircle className="me-2" style={{ color: '#17a2b8' }} />
                    Información del Módulo
                  </h6>
                  <p style={{ color: '#6c757d', marginBottom: '0', fontSize: '0.9rem' }}>
                    Este módulo permite gestionar los cierres de conductores, tanto para revisión diaria 
                    como para generar los reportes mensuales consolidados que incluyen todas las entregas, 
                    pagos y extras correspondientes a cada conductor o empresa.
                  </p>
                </Col>
                <Col xs={12} md={4} className="d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
                  <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                    <div><strong>Permisos actuales:</strong></div>
                    <div>Vista: {permisos.canView ? '✓' : '✗'}</div>
                    <div>Crear: {permisos.canCreate ? '✓' : '✗'}</div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </SimpleMantenedorLayout>
  );
};

export default Cierre;
